const Visible = (props: { if: boolean, children: any }) => {
  if (props.if) {
    return props.children;
  }

  return null;
}

export default Visible;
